/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconHistory8 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconHistory8(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 8 8" ref={ref}>
            <path d="m4.417 3.827-.083-1.825L3.667 2l-.083 2.172 1.188 1.06.438-.437-.793-.968Z" fill="currentColor" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4 .667a3.333 3.333 0 1 0 0 6.666A3.333 3.333 0 0 0 4 .667ZM2.115 2.114a2.667 2.667 0 1 1 3.77 3.771 2.667 2.667 0 0 1-3.77-3.77Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconHistory12 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconHistory12(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 12 12" ref={ref}>
            <path d="M6.625 5.741 6.5 3.004 5.5 3l-.125 3.259 1.783 1.59.656-.656-1.189-1.452Z" fill="currentColor" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6 1a5 5 0 1 0 0 10A5 5 0 0 0 6 1ZM3.172 3.172a4 4 0 1 1 5.656 5.656 4 4 0 0 1-5.656-5.656Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconHistory16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconHistory16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                d="m8.833 7.655-.167-3.65L7.333 4l-.167 4.345 2.378 2.121.875-.875-1.586-1.936Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 1.333a6.667 6.667 0 1 0 0 13.334A6.667 6.667 0 0 0 8 1.334ZM4.228 4.23a5.333 5.333 0 1 1 7.543 7.542A5.333 5.333 0 0 1 4.228 4.23Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconHistory24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconHistory24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path d="M13.25 11.482 13 6.008 11 6l-.25 6.518 3.566 3.181 1.313-1.313-2.379-2.904Z" fill="currentColor" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20ZM6.343 6.343a8 8 0 1 1 11.314 11.314A8 8 0 0 1 6.343 6.343Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconHistory = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconHistory(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '8':
            return <IconHistory8 {...iconProps} />;
        case '12':
            return <IconHistory12 {...iconProps} />;
        case '16':
            return <IconHistory16 {...iconProps} />;
        case '24':
            return <IconHistory24 {...iconProps} />;
        default:
            return <IconHistory24 {...iconProps} />;
    }
});
